import { render, staticRenderFns } from "./ColorIndicator.vue?vue&type=template&id=4653d8f0&scoped=true&lang=pug&"
import script from "./ColorIndicator.vue?vue&type=script&lang=js&"
export * from "./ColorIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ColorIndicator.vue?vue&type=style&index=0&id=4653d8f0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4653d8f0",
  null
  
)

export default component.exports